import { render, staticRenderFns } from "./SeccionContabilidad.vue?vue&type=template&id=32872302&scoped=true"
import script from "./SeccionContabilidad.vue?vue&type=script&lang=js"
export * from "./SeccionContabilidad.vue?vue&type=script&lang=js"
import style0 from "./SeccionContabilidad.vue?vue&type=style&index=0&id=32872302&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32872302",
  null
  
)

export default component.exports